export default {
    state: {
        filters: {
            loginIds: [],
            operations: [],
            query: "",
            date: undefined
        }
    },

    mutations: {
        AUDIT_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value
            };
        },
        AUDIT_RESET_FILTERS(state) {
            state.filters = {
                loginIds: [],
                operations: [],
                query: "",
                date: undefined
            };
        }
    }
};
